import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {StatisticValidationRule, UpperCaseStringValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateUpperCaseString = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<UpperCaseStringValidationRule>(rule, StatisticItemValidationType.UpperCaseString)
  ) {
    return null;
  }
  const statisticValue = statistic.value;

  if (ValidationUtils.isInvalidStringValue(statisticValue)) {
    // логируем некорректное строковое значение
    const error = FrontendError.createInvalidStringValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  }

  return statisticValue.toUpperCase();
};
